import React, { useEffect, useState } from 'react'
import { useRouteMatch } from 'react-router-dom'
import Services from '../services/Services'

function Receipt(props) {
  const [theme, setTheme] = React.useState('')
  useEffect(() => {
    if (theme !== props.theme) {
      setTheme(props.theme)
    }
  }, [props.theme])

  const [order, setOrder] = useState(0)
  const [prepMeal, setPrepMeal] = useState(0)
  const [orderTotal, setOrderTotal] = useState(0)
  const [driver, setDriver] = useState({})
  const [count, setCount] = useState(0)
  let match = useRouteMatch()
  const services = new Services(this)

  const [commissions, setCommissions] = useState({
    delivery_fee: 0,
    tip: 0,
    service_fee: 0,
    hosting_fee: 0,
    coupon_amount: 0,
    discount: 0,
    tax: 0,
  })

  useEffect(() => {
    let orderId = 0
    try {
      orderId = isNaN(parseInt(localStorage.getItem('currentOrderId')))
        ? 0
        : parseInt(localStorage.getItem('currentOrderId'))
    } catch (error) {
      console.log(error)
    }
    if (orderId === 0) {
      window.location.href = '/not-found'
      return
    }

    let prepMeal = 0
    try {
      prepMeal = isNaN(parseInt(localStorage.getItem('currentOrderIsPrepMeal')))
        ? 0
        : parseInt(localStorage.getItem('currentOrderIsPrepMeal'))
    } catch (error) {
      console.log(error)
    }
    setPrepMeal(prepMeal)
    services.getOrder(orderId, prepMeal).then((data) => {
      if (data?.resultcode === 1) {
        setOrder(data)
        setOrderTotal(data.order.total ?? 0)
        setCommissions({
          delivery_fee: data.order_details.delivery_fee ?? 0,
          tip: data.order_details.tip ?? 0,
          service_fee: data.order_details.admin_commission ?? 0,
          coupon_amount: data.order_details.coupon_amount ?? 0,
          discount: data.order_details.discount ?? 0,
          hosting_fee: data.order_details.hosting_fee ?? 0,
          maintenance_fee: data.order_details.maintenance_fee ?? 0,
          tax: data.order_details.tax ?? 0,
        })
      }
    })
    services.getDriver(orderId, prepMeal).then((data) => {
      if (data?.resultcode === 1) {
        setDriver(data)
      }
    })
  }, [])
  const print = () => {
    var content = document.getElementById('div-print')
    var pri = document.getElementById('ifmcontentstoprint').contentWindow
    pri.document.open()
    pri.document.write(content.innerHTML)
    pri.document.close()
    pri.focus()
    pri.print()
  }

  const formatDate = (date) => {
    if (date) {
      date = new Date(date)
      var dateStr =
        date.getFullYear() +
        '-' +
        ('00' + (date.getMonth() + 1)).slice(-2) +
        '-' +
        ('00' + date.getDate()).slice(-2) +
        ' ' +
        ('00' + date.getHours()).slice(-2) +
        ':' +
        ('00' + date.getMinutes()).slice(-2) +
        ':' +
        ('00' + date.getSeconds()).slice(-2)
      return dateStr
    }
    return ''
  }

  return (
    <div className={theme && theme === 'DARK' ? 'dark_theme' : 'light_theme'}>
      <div
        className="main-wrapper inner--page"
        style={{ backgroundColor: '#eff0f2' }}
      >
        <section className="order-location-sec">
          <div className="container">
            <iframe
              id="ifmcontentstoprint"
              style={{ height: '0px', width: '0px', position: 'absolute' }}
            ></iframe>
            <div className="row">
              <div
                className="col-lg-12 col-md-12 col-sm-12"
                style={{ position: 'relation' }}
              >
                <label
                  className="colorgreen no-print"
                  onClick={print}
                  style={{ position: 'absolute', right: '30px', top: '25px' }}
                >
                  <img
                    src="/images/fontisto_print.png"
                    width="18"
                    height="19"
                    alt="print icon"
                  />
                  &nbsp; Print Receipt
                </label>
                <div className="your--order-reciept mt-0" id="div-print">
                  <div
                    className="delivery-guy-info border-bottom"
                    style={{ justifyContent: 'left' }}
                  >
                    <div className="profile-img mr-3">
                      <h4>Your Order</h4>
                    </div>
                    <div
                      className="contact-number"
                      style={{ justifyContent: 'left' }}
                    >
                      <span style={{ marginRight: '20pt' }}>
                        Order No #{order?.order_details?.receiptno}
                      </span>
                      <span style={{ marginRight: '20pt' }}>
                        Date: {formatDate(order?.order_details?.created_at)}
                      </span>
                    </div>
                  </div>
                  <div className="receipt-price-list">
                    <div className="order-listing">
                      <ul>
                        {order?.order_items?.map((item, index) => {
                          return (
                            <li key={index}>
                              <p>
                                <span>{item.quantity}x</span> {item.meal_name}
                              </p>
                              <p>JMD ${item.quantity * item.price}</p>
                            </li>
                          )
                        })}
                      </ul>
                    </div>
                  </div>

                  <hr />

                  <div
                    className="order-listing_"
                    style={{ textAlign: 'right' }}
                  >
                    <table
                      style={{ marginRight: '0', display: 'inline-block' }}
                    >
                      <tbody>
                        <tr>
                          <td>
                            <p>Item subtotal:</p>
                          </td>
                          <td>
                            <p>JMD ${orderTotal}</p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>Discount:</p>
                          </td>
                          <td>
                            <p>{commissions.discount}%</p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>Delivery fee:</p>
                          </td>
                          <td>
                            <p>JMD ${commissions.delivery_fee}</p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>Service fees:</p>
                          </td>
                          <td>
                            <p>JMD ${commissions.service_fee}</p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>Hosting fees:</p>
                          </td>
                          <td>
                            <p>JMD ${commissions.hosting_fee}</p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>Tax:</p>
                          </td>
                          <td>
                            <p>JMD ${commissions.tax}</p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>Driver tip:</p>
                          </td>
                          <td>
                            <p>JMD ${commissions.tip}</p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>Coupon Amount:</p>
                          </td>
                          <td>
                            <p>JMD ${commissions.coupon_amount}</p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>
                              <b>Total Cost:</b>
                            </p>
                          </td>
                          <td>
                            <p>
                              <b>
                                JMD $
                                {parseInt(
                                  (orderTotal * (100 - commissions.discount)) /
                                    100,
                                ) +
                                  parseFloat(commissions.delivery_fee) +
                                  parseFloat(commissions.tip) +
                                  parseFloat(commissions.tax) +
                                  parseFloat(commissions.hosting_fee) +
                                  parseFloat(commissions.service_fee) -
                                  parseFloat(commissions.coupon_amount)}
                              </b>
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default Receipt
